import { ref } from "vue"

import { unleashClient } from "@/plugins/unleash"

export default function featureFlagCheck(to, _from, next) {
  const featureName = to.meta.featureFlag

  if (featureName) {
    const flag = ref(Boolean(unleashClient.isEnabled(featureName)))

    flag.value ? next() : next({ name: "Error" })
  } else {
    next()
  }
}
